import styled from 'styled-components';

export const StyledUserPanelParent = styled.section`
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
`;
